( function ( $ ) {
	class TimeZone {

		/**
		 * Constructor.
		 *
		 * @return {void}
		 */
		constructor() {

			const bodyEl = $( 'body' );

			// Initialize slider only on 'Audience Home page', 'Single Stories page'
			if (
				document.getElementById('ebayads-time-zones') !== null
			) {

				this.clockElements = document.getElementsByClassName( 'clock' );

				if ( !this.clockElements ) {
					return;
				}

				this.initializeClock();
			}
		}

		/**
		 * Initialize TimeZones
		 */
		initializeClock() {
			setTimeout( () => this.startClocks(), 100 );
		}

		/**
		 * Convert the date to text.
		 *
		 * @param {string} date Date.
		 * @return {string}
		 */
		dateToText( date ) {
			let hours   = date.getHours()
			let minutes = date.getMinutes();
			if ( minutes < 10 ) minutes = '0' + minutes;
			if ( hours < 10 ) hours = '0' + hours;
			return hours + ":" + minutes; // + ":" + seconds;
		}

		updateClocks() {
			for( let i = 0; i < this.arrClocks.length; i++ ) {
				let clock       = this.arrClocks[ i ];
				let offset      = this.arrOffsets[ i ];
				clock.innerHTML = this.dateToText( new Date( new Date().getTime() + offset ) );
			}
		}

		/**
		 * Start the clock.
		 */
		startClocks() {

			this.arrClocks  = [];
			this.arrOffsets = [];

			for( let i = 0; i < this.clockElements.length; i++ ) {
				this.el       = this.clockElements[ i ];
				this.timezone = parseInt( this.el.getAttribute( 'data-timezone' ) );
				if ( !isNaN( this.timezone ) ) {
					let tzDifference = this.timezone * 60 + ( new Date() ).getTimezoneOffset();
					let offset       = tzDifference * 60 * 1000;
					this.arrClocks.push( this.el );
					this.arrOffsets.push( offset );
				}
			}

			this.updateClocks();
			const clockID = setInterval( () => this.updateClocks(), 1000 );
		}

	}

	new TimeZone();

} )( jQuery );
